import store from '@/store'
import router from '@/router'

router.beforeEach(async (to, from, next) => {
    let toPath = to.path;
    //管理中心左侧菜单栏激活
    switch (toPath) {
        case '/':
        case '/index':
            store.dispatch('updateActiveMenuKey', 1);
            break;
        case '/product/iot':
            store.dispatch('updateActiveMenuKey', 10);
            break;
        case '/product/furnishing':
            store.dispatch('updateActiveMenuKey', 11);
            break;
        case '/solution/community':
            store.dispatch('updateActiveMenuKey', 5);
            break;
        case '/solution/park':
            store.dispatch('updateActiveMenuKey', 6);
            break;
        case '/solution/traffic':
            store.dispatch('updateActiveMenuKey', 7);
            break;
        case '/solution/scenic':
            store.dispatch('updateActiveMenuKey', 8);
            break;
        case '/solution/hotel':
            store.dispatch('updateActiveMenuKey', 9);
            break;
        case '/about':
            store.dispatch('updateActiveMenuKey', 4);
            break;
    }
    next();
});
